import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageWrapper from '../components/UI/PageWrapper';
import UserInvitations from '../components/Invitations/UserInvitations';
import { useArtist } from '../contexts/ArtistContext';
import { useUser } from '../contexts/UserContext';
import { getFirstAccessibleRoute } from '../utils/routePermissionUtils';

const InvitationsPage = () => {
  const navigate = useNavigate();
  const { pendingInvitations, loadingInvitations, currentPermissions } = useArtist();
  const { userProfile } = useUser();

  // Get system admin status
  const getSystemRole = (): string | null => {
    try {
      return sessionStorage.getItem('systemRole') || userProfile?.systemRole || null;
    } catch {
      return null;
    }
  };
  const isSystemAdmin = getSystemRole() === 'system_admin';

  // Navigate to first category if no pending invitations (only active teams)
  useEffect(() => {
    // Filter to only count active team invitations
    const activePendingInvitations = pendingInvitations?.filter(
      (inv) => inv.teamIsActive === true
    ) || [];
    
    if (!loadingInvitations && activePendingInvitations.length === 0) {
      const firstRoute = getFirstAccessibleRoute(currentPermissions, isSystemAdmin);
      navigate(firstRoute);
    }
  }, [pendingInvitations, loadingInvitations, currentPermissions, isSystemAdmin, navigate]);

  // Show loading while checking for pending invitations
  if (loadingInvitations) {
    return (
      <PageWrapper>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-gray-600 font-family-messina-sans">Loading...</div>
        </div>
      </PageWrapper>
    );
  }

  // Show invitations page if user has pending invitations
  return (
  <PageWrapper>
    <UserInvitations />
  </PageWrapper>
);
};

export default InvitationsPage;

